/* ==========================================================================
   Monk Add to Cart — local, self-contained replacement for the FoxCart app.
   Features:
   - quick-add buttons on product grid cards (with quantity stepper)
   - sticky add-to-cart bar on product pages
   - floating cart bubble (links to cart, live item count)
   - "added to cart" toast + fly-to-cart animation
   - AJAX interception of the native product form (no page reload)
   ========================================================================== */
(function () {
  'use strict';
  if (window.__monkATC) return;
  window.__monkATC = true;

  var cfg = window.monkATC || {};
  var themeRoutes = (window.theme && window.theme.routes) || {};
  var cartUrl = cfg.cartUrl || themeRoutes.cart || '/cart';
  var cartAddUrl = cfg.cartAddUrl || themeRoutes.cart_add_url || '/cart/add';
  var moneyFormat = cfg.moneyFormat || (window.theme && window.theme.moneyFormat) || 'R {{amount}}';
  var isDesignMode = !!(window.Shopify && window.Shopify.designMode);

  var ADD_LABEL = 'Add to cart';
  var SOLD_OUT_LABEL = 'SOLD OUT';
  var TOAST_TEXT = 'added to cart';

  /* ---------- helpers ----------------------------------------------------- */

  function formatMoney(cents, format) {
    var formatString = format || 'R {{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    function defaultTo(input, def) { return (typeof input === 'undefined' || input === null) ? def : input; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount': default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addItem(id, quantity) {
    return fetch(cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) {
          throw new Error((body && (body.description || body.message)) || 'Add to cart failed');
        }
        return body;
      });
    });
  }

  function updateIndicators(cart) {
    var countEl = document.querySelector('[data-header-cart-count]');
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    var priceEl = document.querySelector('[data-header-cart-price]');
    if (priceEl) priceEl.textContent = formatMoney(cart.total_price, moneyFormat);
    var fullEl = document.querySelector('[data-header-cart-full]');
    if (fullEl) fullEl.setAttribute('data-header-cart-full', cart.item_count > 1 ? 'true' : 'false');
    var badge = document.getElementById('mda-count');
    if (badge) badge.textContent = cart.item_count;
    updateMinOrder(cart);
  }

  /* ---------- wholesale minimum helper ------------------------------------ */

  var MIN_CARDS = cfg.minCards || 30;

  function cardCount(cart) {
    var n = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var sku = String(it.sku || '').toUpperCase();
      var title = String(it.title || '').toLowerCase();
      if (sku.indexOf('STA') === 0 || title.indexOf('stand') !== -1) continue; /* display stands don't count */
      var pack = title.match(/(\d+)\s*pack/); /* "best sellers 60 pack" counts as 60 cards */
      if (pack) { n += it.quantity * parseInt(pack[1], 10); continue; }
      n += it.quantity;
    }
    return n;
  }

  function updateMinOrder(cart) {
    var n = cardCount(cart);
    cartCards = n;   /* the header cart links need this synchronously */
    var spots = [];
    var cartEl = document.querySelector('.template__cart__footer .cart__footer__total');
    if (cartEl && cartEl.parentNode) spots.push({ parent: cartEl.parentNode, before: cartEl });
    var drawerEl = document.querySelector('[data-cart-bottom] .drawer__footer__subtotal');
    if (drawerEl && drawerEl.parentNode) spots.push({ parent: drawerEl.parentNode, before: drawerEl });

    for (var i = 0; i < spots.length; i++) {
      var spot = spots[i];
      var el = spot.parent.querySelector('.mda-minorder');
      if (!el) {
        el = document.createElement('div');
        el.className = 'mda-minorder mda-noselect';
        spot.parent.insertBefore(el, spot.before);
      }
      if (!n) { if (el.style.display !== 'none') el.style.display = 'none'; continue; }
      if (el.style.display !== '') el.style.display = '';
      var msg;
      if (n >= MIN_CARDS) {
        if (!el.classList.contains('is-ok')) el.classList.add('is-ok');
        msg = 'Wholesale minimum reached \u2014 ' + n + ' cards in your cart \u2713';
      } else {
        if (el.classList.contains('is-ok')) el.classList.remove('is-ok');
        msg = 'Wholesale minimum: ' + n + ' of ' + MIN_CARDS + ' cards (' +
              (MIN_CARDS - n) + ' more before you can check out)';
      }
      if (el.textContent !== msg) el.textContent = msg;
    }
    lockCheckout(n > 0 && n < MIN_CARDS);
  }

  /* Hold the order at the wholesale minimum: while the cart holds fewer than
     MIN_CARDS cards the checkout buttons stay disabled and any extra checkout
     buttons are hidden. The note above the total says how many are missing, so a
     locked button is never a mystery. A customer who types the /checkout address
     can still get through - only a Shopify checkout validation rule can stop
     that, and that needs the CLI to deploy. */
  function lockCheckout(short) {
    var btns = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (short) {
        if (!b.disabled) b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.setAttribute('title', 'Wholesale minimum: ' + MIN_CARDS + ' cards');
        if (!b.classList.contains('mda-locked')) b.classList.add('mda-locked');
      } else if (b.classList.contains('mda-locked')) {
        b.disabled = false;
        b.removeAttribute('aria-disabled');
        b.removeAttribute('title');
        b.classList.remove('mda-locked');
      }
    }
    var alts = document.querySelectorAll(
      '.drawer__checkout__additional, .additional-checkout-buttons, ' +
      '.shopify-payment-button');
    for (var j = 0; j < alts.length; j++) {
      alts[j].style.display = short ? 'none' : '';
    }
  }

  function watchCartChanges() {
    if (!window.MutationObserver) return;
    var zones = document.querySelectorAll('[data-cart-bottom]');
    if (!zones.length) return;
    var timer = null;
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        getCart().then(updateIndicators).catch(function () {});
      }, 400);
    });
    for (var i = 0; i < zones.length; i++) {
      obs.observe(zones[i], { childList: true, subtree: true, characterData: true });
    }
  }

  function imgSrc(el) {
    if (!el) return null;
    if (el.tagName === 'IMG') return el.currentSrc || el.src;
    var bg = getComputedStyle(el).backgroundImage;
    if (bg && bg !== 'none') return bg.slice(5, -2).replace(/"/g, '');
    return null;
  }

  function pickProductImage() {
    return document.querySelector('.product__photo img, .product__media img, [data-photoswipe-gallery] img, .product__media__wrapper img');
  }

  /* ---------- toast ------------------------------------------------------- */

  var toastEl = null;
  var toastTimer = null;

  function buildToast() {
    if (toastEl) return;
    toastEl = document.createElement('div');
    toastEl.id = 'mda-toast';
    toastEl.setAttribute('role', 'status');
    var msg = document.createElement('div');
    msg.className = 'mda-msg';
    msg.textContent = TOAST_TEXT;
    toastEl.appendChild(msg);
    toastEl.addEventListener('click', function () { window.location.href = cartUrl; });
    document.body.appendChild(toastEl);
  }

  function showToast() {
    buildToast();
    toastEl.classList.add('mda-toast-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('mda-toast-in'); }, 2600);
  }

  /* ---------- floating cart bubble ---------------------------------------- */

  var bubbleEl = null;

  function onCartPage() {
    var path = window.location.pathname;
    var c = cartUrl.length > 1 && cartUrl.charAt(cartUrl.length - 1) === '/' ? cartUrl.slice(0, -1) : cartUrl;
    return path === c || path === c + '/';
  }

  function buildBubble() {
    if (bubbleEl || onCartPage()) return;
    bubbleEl = document.createElement('div');
    bubbleEl.id = 'mda-bubble';
    bubbleEl.setAttribute('role', 'link');
    bubbleEl.setAttribute('tabindex', '0');
    bubbleEl.setAttribute('aria-label', 'Cart');
    bubbleEl.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 64 64">' +
      '<g stroke-width="4" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M24 26 a 8 8 0 0 1 16 0"></path>' +
      '<path d="M17.5 26 h29 l3.5 32 h-36 z"></path>' +
      '</g></svg>' +
      '<span id="mda-count">0</span>';
    bubbleEl.addEventListener('click', onBubbleAction);
    bubbleEl.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); onBubbleAction(ev); }
    });
    document.body.appendChild(bubbleEl);
  }

  function pulseBubble() {
    if (!bubbleEl) return;
    bubbleEl.classList.remove('mda-bounce');
    void bubbleEl.offsetWidth;
    bubbleEl.classList.add('mda-bounce');
  }

  /* ---------- "not at the minimum yet" feedback ----------------------------
     Clicking the cart bubble while the order is still under the minimum shakes
     the button and explains why, then still opens the cart (that is where the
     extra cards get added). The count is fetched at click time so a stale
     number can never scold a customer who is already over the minimum. */

  var noteEl = null;
  var noteTimer = null;
  var cartCards = 0;

  function showMinNote(html) {
    if (!noteEl) {
      noteEl = document.createElement('div');
      noteEl.id = 'mda-note';
      noteEl.setAttribute('role', 'status');
      document.body.appendChild(noteEl);
    }
    noteEl.innerHTML = html;
    noteEl.classList.add('mda-note-in');
    if (noteTimer) window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      noteEl.classList.remove('mda-note-in');
    }, 4200);
  }

  function warnMinimum(n, el) {
    var target = el || bubbleEl;
    if (target) {
      target.classList.remove('mda-vibe');
      void target.offsetWidth;
      target.classList.add('mda-vibe');
      window.setTimeout(function () { target.classList.remove('mda-vibe'); }, 1200);
    }
    showMinNote('Minimum order is <b>' + MIN_CARDS + ' cards</b> \u2014 you have ' +
                n + ' so far, ' + (MIN_CARDS - n) + ' more to go.');
  }

  /* Nothing navigates while the order is short: the customer stays on the page
     they are shopping on so they can pick up the rest of the cards. */
  function onBubbleAction(ev) {
    if (ev && ev.preventDefault) ev.preventDefault();
    getCart().then(function (cart) {
      var n = cardCount(cart);
      cartCards = n;
      if (n && n < MIN_CARDS) { warnMinimum(n, bubbleEl); return; }
      window.location.href = cartUrl;
    }).catch(function () { window.location.href = cartUrl; });
  }

  /* The header cart links (desktop nav and the mobile button) open the cart
     drawer. Clicking them before the minimum is reached wobbles them gently and
     explains, without opening anything. This decision has to be synchronous, so
     it uses the count kept current by the cart fetches, and it runs in the
     capture phase so it beats the theme's own drawer handler. */
  function watchCartLinks() {
    var links = document.querySelectorAll(
      'a[data-drawer-toggle="drawer-cart"], a.navlink--cart, a[href$="/cart"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.id === 'mda-bubble' || a.getAttribute('data-mda-watch')) continue;
      a.setAttribute('data-mda-watch', '1');
      a.addEventListener('click', function (ev) {
        if (cartCards && cartCards < MIN_CARDS) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          warnMinimum(cartCards, a);
        }
      }, true);
    }
  }

  /* ---------- fly-to-cart animation --------------------------------------- */

  function flyToBubble(sourceEl) {
    var src = imgSrc(sourceEl);
    if (!src || !bubbleEl) return;
    var s = sourceEl.getBoundingClientRect();
    var e = bubbleEl.getBoundingClientRect();
    if (!s.width || !s.height) return;
    var clone = document.createElement('div');
    clone.className = 'mda-fly';
    clone.style.left = s.left + 'px';
    clone.style.top = s.top + 'px';
    clone.style.width = s.width + 'px';
    clone.style.height = s.height + 'px';
    clone.style.backgroundImage = 'url("' + src + '")';
    document.body.appendChild(clone);
    var scale = 40 / Math.max(s.width, s.height);
    var dx = (e.left + e.width / 2) - (s.left + s.width / 2);
    var dy = (e.top + e.height / 2) - (s.top + s.height / 2);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
        clone.style.opacity = '0.25';
        clone.style.borderRadius = '50%';
      });
    });
    setTimeout(function () { if (clone.parentNode) clone.parentNode.removeChild(clone); }, 850);
  }

  /* ---------- add flow ----------------------------------------------------- */

  function qtyInputFor(btn) {
    var bar = btn.closest('#mda-bar');
    if (bar) return bar.querySelector('#mda-bar-qty');
    var holder = btn.closest('[data-mda-holder]');
    return holder ? holder.querySelector('[data-mda-qty]') : null;
  }

  function handleAdd(btn) {
    if (!btn || btn.hasAttribute('data-soldout')) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var qty = 1;
    var qtyInput = qtyInputFor(btn);
    if (qtyInput) {
      qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
    }
    var bar = btn.closest('#mda-bar');
    var holder = btn.closest('[data-mda-holder]');
    var img = null;
    if (bar) {
      img = bar.querySelector('.mda-bar-img');
    } else if (holder) {
      var card = holder.closest('.product-grid-item');
      img = card ? (card.querySelector('.collection__image__top') || card.querySelector('img')) : null;
    }
    if (!img) img = pickProductImage();

    btn.classList.add('mda-loading');
    addItem(id, qty).then(getCart).then(function (cart) {
      updateIndicators(cart);
      showToast();
      pulseBubble();
      flyToBubble(img);
    }).catch(function (err) {
      if (window.console && console.warn) console.warn('[monk-atc]', err && err.message ? err.message : err);
    }).then(function () {
      btn.classList.remove('mda-loading');
    });
  }

  function stepQty(el, dir) {
    var bar = el.closest('#mda-bar');
    var holder = el.closest('[data-mda-holder]');
    var input = bar ? bar.querySelector('#mda-bar-qty') : (holder ? holder.querySelector('[data-mda-qty]') : null);
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = 1;
    v += dir;
    if (v < 1) v = 1;
    input.value = v;
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-mda-add]');
    if (btn) { ev.preventDefault(); handleAdd(btn); return; }
    var up = t.closest('[data-mda-up],[data-mda-bar-up]');
    if (up) { stepQty(up, 1); return; }
    var down = t.closest('[data-mda-down],[data-mda-bar-down]');
    if (down) { stepQty(down, -1); return; }
  });

  /* native product form interception (capture phase, before theme handlers) */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-product-form')) return;
    var idEl = form.querySelector('input[name="id"]');
    if (!idEl || !idEl.value) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (isDesignMode) return;
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('mda-loading');
    addItem(idEl.value, qty).then(getCart).then(function (cart) {
      updateIndicators(cart);
      showToast();
      pulseBubble();
      flyToBubble(pickProductImage());
    }).catch(function (err) {
      if (window.console && console.warn) console.warn('[monk-atc]', err && err.message ? err.message : err);
    }).then(function () {
      if (btn) btn.classList.remove('mda-loading');
    });
  }, true);

  /* ---------- sticky product bar ------------------------------------------- */

  function readProductJSON() {
    var el = document.querySelector('script[data-mda-product]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function buildBar(product) {
    if (!product || !product.variantId || document.getElementById('mda-bar')) return;
    var available = product.available !== false;
    var bar = document.createElement('div');
    bar.id = 'mda-bar';
    bar.innerHTML =
      '<div class="mda-bar-center">' +
        '<span class="mda-bar-imtitle">' +
          '<span class="mda-bar-imgwrap"><img class="mda-bar-img" src="' + esc(product.image || '') + '" alt=""></span>' +
          '<span class="mda-bar-name">' + esc(product.title) + '</span>' +
        '</span>' +
        '<span class="mda-bar-qwrap"' + (available ? '' : ' style="display:none"') + '>' +
          '<input id="mda-bar-qty" type="text" inputmode="numeric" pattern="[0-9]*" value="1" aria-label="Quantity" autocomplete="off">' +
          '<i class="mda-bar-up" data-mda-bar-up aria-hidden="true"></i>' +
          '<i class="mda-bar-down" data-mda-bar-down aria-hidden="true"></i>' +
        '</span>' +
        '<div class="mda-bar-btn" data-mda-add data-variant-id="' + esc(product.variantId) + '"' +
          (available ? '' : ' data-soldout="true"') + ' title="' + ADD_LABEL + '">' +
          '<span data-mda-label>' + (available ? ADD_LABEL : SOLD_OUT_LABEL) + '</span>' +
          '<span class="mda-spin" aria-hidden="true"></span>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bar);

    var form = document.querySelector('form[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var shown = false;

    function update() {
      var rect = form.getBoundingClientRect();
      var should = rect.bottom < 0;
      if (should === shown) return;
      shown = should;
      if (should) {
        bar.classList.remove('mda-bar-out');
        bar.classList.add('mda-bar-in');
      } else {
        bar.classList.remove('mda-bar-in');
        bar.classList.add('mda-bar-out');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- init --------------------------------------------------------- */

  function init() {
    buildToast();
    buildBubble();
    buildBar(readProductJSON());
    watchCartChanges();
    watchCartLinks();
    getCart().then(updateIndicators).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
